export default "__VITE_ASSET__DS2O1S7g__"